// common for Investment components and App
import VueChart from 'vue-chart-js';
import Accounting from 'accounting';
import NumberInput from '~/components/number-input.vue';
import DropDown from '~/components/drop-down.vue';
import OnOffToggle from '~/components/on-off-toggle.vue';
import LoanTermList from '~/constants/loan-term-list';
import BaseMixin from '~/mixin/base-mixin';
import Table from '../components/table.vue';

export default {
    data() {
        return {
            circleGraph: true,
            barGraph: false,
            CompoundInterval: this.compoundInterval,
            CompoundIntervalList: LoanTermList.CompoundIntervalList,
            CompoundIntervalTooltip: parseInt(this.hideTooltip, 10) ? '' : this.compoundIntervalTooltip,
            AmortizationsByYear: [],
            MaxEdgeValue: this.maxEdgeValue,
            PaymentPeriods: this.paymentPeriods,
            AdditionalContribution: this.additionalContribution,
            EstimatedTotal: this.estimatedTotal,
            // Circle Graph Settings
            pieChartData: {
                labels: [this.graphContributionOption2, this.graphContributionOption1, this.graphContributionOption3],
                datasets: [
                    {
                        label: '',
                        data: [40, 40, 20],
                        backgroundColor: [
                            '#00aeef',
                            '#08c177',
                            '#078181',
                        ],
                        borderWidth: 1,
                    },
                ],
            },
            pieChartOptions: {
                cutoutPercentage: 0,
                legend: {
                    display: false,
                },
                tooltips: {
                    titleFontStyle: 'bold',
                    callbacks: {
                        title(tooltipItems, data) {
                            const labelIndex = tooltipItems[0].index;
                            const actualLabel = data.labels[labelIndex];
                            return actualLabel;
                        },
                        label(tooltipItem, data) {
                            const value = `${Math.round(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index])}`;
                            return ` $${Accounting.formatNumber(value)}`;
                        },
                    },
                },
            },
            // Bar Graph Settings
            barChartData: {
                labels: ['2020 ', '2021 ', '2022 ', '2023 '],
                datasets: [
                    {
                        label: this.graphContributionOption1,
                        backgroundColor: '#08c177',
                        data: [65, 65, 65, 65],
                        borderWidth: 1,
                        borderColor: '#fff',
                        hoverBorderColor: '#fff',
                        categoryPercentage: 1,
                        barPercentage: 0.65,
                    }, {
                        label: this.graphContributionOption2,
                        backgroundColor: '#00aeef',
                        data: [35, 60, 65, 70],
                        borderWidth: 1,
                        borderColor: '#fff',
                        hoverBorderColor: '#fff',
                        categoryPercentage: 1,
                        barPercentage: 0.65,
                    }, {
                        label: this.graphContributionOption3,
                        backgroundColor: '#078181',
                        data: [35, 35, 35, 40],
                        borderWidth: 1,
                        borderColor: '#fff',
                        hoverBorderColor: '#fff',
                        categoryPercentage: 1,
                        barPercentage: 0.65,
                    },
                ],
            },
            barChartWidth: 300,
            barChartHeight: 240,
            barChartOptions: {
                legend: {
                    display: false,
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            fontColor: '#777',
                            fontSize: 10,
                            padding: 10,
                            beginAtZero: true,
                        },
                        gridLines: [{
                            display: false,
                        }],
                    }],
                    yAxes: [{
                        stacked: true,
                        gridLines: {
                            color: '#eee',
                            drawBorder: false,
                        },
                        ticks: {
                            beginAtZero: true,
                            fontColor: '#777',
                            fontSize: 10,
                            padding: 10,
                            min: 0,
                            max: this.MaxEdgeValue,
                            callback(value) {
                                return value >= 1 ? ` $${value / 1000}K` : 0;
                            },
                        },
                    }],
                },
                tooltips: {
                    titleFontStyle: 'bold',
                    callbacks: {
                        title(tooltipItems, data) {
                            const labelIndex = tooltipItems[0].index;
                            return data.labels[labelIndex];
                        },
                        label(tooltipItem, data) {
                            const value = ` ${data.datasets[tooltipItem.datasetIndex].label}: $${Accounting.formatNumber(Math.round(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]))}`;
                            return `${value}`;
                        },
                    },
                },
            },
        };
    },
    props: {
        labelAdditionalContribution: {
            default: '',
        },
        additionalContribution: {
            default: 200,
        },
        labelCompoundInterval: {
            default: 'Compound Interval',
        },
        compoundInterval: {
            default: '12',
        },
        compoundIntervalTooltip: {
            default: '',
        },
        rightSectionHeaderText: {
            default: '',
        },
        contentHeaderText: {
            default: '',
        },
        rightSectionGraphTitle: {
            default: '',
        },
        rightSectionGraphTitleOnMobile: {
            default: '',
        },
        rightSectionBarChartTitle: {
            default: '',
        },
        rightSectionBarChartTitleOnMobile: {
            default: '',
        },
        graphContributionOption1: {
            default: '',
        },
        graphContributionOption2: {
            default: '',
        },
        graphContributionOption3: {
            default: '',
        },
        submitButtonText: {
            default: '',
        },
        isPiChartVisible: {
            default: true,
        },
        isBarChartVisible: {
            default: true,
        },
        isAmortizationTableVisible: {
            default: true,
        },
        estimatedTotal: {
            default: 0,
        },
        maxEdgeValue: {
            default: 0,
        },
        paymentPeriods: {
            default: 12,
        },
        contributionStatus: {
            default: 'monthly',
        },
    },
    methods: {
        formatFigure(figure) {
            return Accounting.formatMoney(figure, { symbol: '$', precision: 2 });
        },
        formatNumber(number) {
            return Accounting.formatNumber(number, { precision: 2 });
        },
        updateContributionStatus(value) {
            this.PaymentPeriods = value === 'monthly' ? 12 : 1;
            this.calculate();
        },
    },
    mounted() {
        this.calculate();
    },
    watch: {
        getFieldValue() {
            this.calculate();
        },
    },
    components: {
        NumberInput,
        DropDown,
        OnOffToggle,
        VueChart,
        Table,
    },
    mixins: [BaseMixin],
};
